import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ShieldCheck, ArrowRight } from "lucide-react";
import { RoleBadge } from "@/components/collaboration/RoleBadge";
import { ROLE_META } from "@/lib/team-roles";

/**
 * Role reference for Settings. Member editing lives in Team Management
 * (single source of truth) — this panel only explains the role model.
 */
export const UserPermissions = () => {
  return (
    <Card className="p-6">
      <div className="mb-4 flex items-center justify-between gap-4">
        <div>
          <h2 className="flex items-center gap-2 text-lg font-semibold">
            <ShieldCheck className="h-5 w-5 text-muted-foreground" />
            User Permissions
          </h2>
          <p className="text-sm text-muted-foreground">
            Roles decide what each teammate can do in your workspace.
          </p>
        </div>
        <Button asChild variant="outline" size="sm">
          <Link to="/team-management">
            Manage teams
            <ArrowRight className="ml-2 h-4 w-4" />
          </Link>
        </Button>
      </div>

      <div className="space-y-3">
        {(["owner", "admin", "editor", "viewer"] as const).map((role) => (
          <div key={role} className="flex items-start gap-3 rounded-lg border p-3">
            <RoleBadge role={role} />
            <p className="text-sm text-muted-foreground">{ROLE_META[role].description}</p>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default UserPermissions;
